// extracted by mini-css-extract-plugin
export default {"fadeInLeft":"fadeInLeft--Uq7CO","fadeInRight":"fadeInRight--cTpCv","fadeInDown":"fadeInDown--WeF2l","fadeInUp":"fadeInUp--SC3KK","zoomIn":"zoomIn--N4FKv"};